import { render } from "./QuizList.vue?vue&type=template&id=062e4521&scoped=true"
import script from "./QuizList.vue?vue&type=script&lang=js"
export * from "./QuizList.vue?vue&type=script&lang=js"

import "./QuizList.vue?vue&type=style&index=0&id=062e4521&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062e4521"]])

export default __exports__